/**
 * @generated SignedSource<<460e4bf18d4eaff21eca88263ccf90ce>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { Url } from "@/common/relayCustomScalar";
export type CompetitionScaffoldQuery$variables = {
  competitionSlug: string;
  eventSlug: string;
};
export type CompetitionScaffoldQuery$data = {
  readonly competitionBySlug: {
    readonly banner: Url | null | undefined;
    readonly createdAt: DateTime;
    readonly currentStage: {
      readonly noCode: boolean;
      readonly submissionDeadline: DateTime | null | undefined;
    };
    readonly description: string | null | undefined;
    readonly event: {
      readonly id: string;
    };
    readonly hasLeaderboard: boolean;
    readonly host: {
      readonly displayName: string;
      readonly id: string;
      readonly username: string;
      readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
    };
    readonly id: string;
    readonly isPrivate: boolean;
    readonly membership: {
      readonly id: string;
    } | null | undefined;
    readonly requiresApproval: boolean;
    readonly shortDescription: string;
    readonly slug: string;
    readonly templates: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly version: Semver;
        readonly workspace: {
          readonly slug: string;
        };
      }>;
    };
    readonly thumbnail: Url | null | undefined;
    readonly title: string;
    readonly viewerCanApprove: boolean;
    readonly viewerCanEdit: boolean;
    readonly viewerCanEditMembers: boolean;
    readonly viewerWorkspace: {
      readonly id: string;
      readonly publishedVersions: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly version: Semver;
        }>;
      };
      readonly slug: string;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"CompetitionJoinButtonFragment" | "CompetitionSetupButtonFragment">;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
  };
};
export type CompetitionScaffoldQuery = {
  response: CompetitionScaffoldQuery$data;
  variables: CompetitionScaffoldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "competitionSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventSlug"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "competitionSlug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "banner",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v12 = {
  "alias": "viewerCanEdit",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_COMPETITION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_COMPETITION\")"
},
v13 = {
  "alias": "viewerCanEditMembers",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "ADD_COMPETITION_MEMBER"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"ADD_COMPETITION_MEMBER\")"
},
v14 = {
  "alias": "viewerCanApprove",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_PROJECT_VERSION_APPROVAL"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLeaderboard",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresApproval",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noCode",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submissionDeadline",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "CompetitionMembership",
  "kind": "LinkedField",
  "name": "membership",
  "plural": false,
  "selections": (v3/*:: as any*/),
  "storageKey": null
},
v21 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v23 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "viewerWorkspace",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v5/*:: as any*/),
    {
      "alias": "publishedVersions",
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "published": true
          }
        },
        (v23/*:: as any*/)
      ],
      "concreteType": "WorkspaceVersionConnection",
      "kind": "LinkedField",
      "name": "versions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkspaceVersion",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v2/*:: as any*/),
            (v22/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "versions(filters:{\"published\":true},first:1)"
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "slug",
      "variableName": "eventSlug"
    }
  ],
  "concreteType": "EventCompetition",
  "kind": "LinkedField",
  "name": "event",
  "plural": false,
  "selections": (v3/*:: as any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v29 = [
  (v28/*:: as any*/),
  (v2/*:: as any*/)
],
v30 = [
  (v5/*:: as any*/),
  (v2/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": (v3/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          (v14/*:: as any*/),
          (v15/*:: as any*/),
          (v16/*:: as any*/),
          (v17/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionStage",
            "kind": "LinkedField",
            "name": "currentStage",
            "plural": false,
            "selections": [
              (v18/*:: as any*/),
              (v19/*:: as any*/)
            ],
            "storageKey": null
          },
          (v20/*:: as any*/),
          {
            "alias": null,
            "args": (v21/*:: as any*/),
            "concreteType": "CompetitionTemplateConnection",
            "kind": "LinkedField",
            "name": "templates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v22/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Workspace",
                    "kind": "LinkedField",
                    "name": "workspace",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "templates(first:2)"
          },
          (v24/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "host",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "thumbnail",
                    "value": true
                  }
                ],
                "kind": "FragmentSpread",
                "name": "EntityProfilePicFragment"
              }
            ],
            "storageKey": null
          },
          (v27/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompetitionSetupButtonFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompetitionJoinButtonFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": (v29/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          (v14/*:: as any*/),
          (v15/*:: as any*/),
          (v16/*:: as any*/),
          (v17/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionStage",
            "kind": "LinkedField",
            "name": "currentStage",
            "plural": false,
            "selections": [
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v20/*:: as any*/),
          {
            "alias": null,
            "args": (v21/*:: as any*/),
            "concreteType": "CompetitionTemplateConnection",
            "kind": "LinkedField",
            "name": "templates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v22/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Workspace",
                    "kind": "LinkedField",
                    "name": "workspace",
                    "plural": false,
                    "selections": (v30/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "templates(first:2)"
          },
          (v24/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "host",
            "plural": false,
            "selections": [
              (v28/*:: as any*/),
              (v2/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isEntity"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageThumbnail",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v27/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UseCase",
            "kind": "LinkedField",
            "name": "useCase",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectVersion",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "kind",
                        "value": "TEMPLATE"
                      }
                    ],
                    "concreteType": "ProjectVersionFile",
                    "kind": "LinkedField",
                    "name": "fileByKind",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kind",
                        "storageKey": null
                      },
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "extension",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectVersion",
                        "kind": "LinkedField",
                        "name": "projectVersion",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v28/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Competition",
                                "kind": "LinkedField",
                                "name": "competition",
                                "plural": false,
                                "selections": (v30/*:: as any*/),
                                "storageKey": null
                              },
                              (v2/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "fileByKind(kind:\"TEMPLATE\")"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "viewerCanAgree",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "CREATE_COMPETITION_RULE_AGREEMENT"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"CREATE_COMPETITION_RULE_AGREEMENT\")"
          },
          {
            "alias": "viewerCanJoin",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "JOIN_COMPETITION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"JOIN_COMPETITION\")"
          },
          {
            "alias": null,
            "args": [
              (v23/*:: as any*/)
            ],
            "concreteType": "CompetitionRuleAgreementConnection",
            "kind": "LinkedField",
            "name": "entityRuleAgreements",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionRuleAgreement",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": "entityRuleAgreements(first:1)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Forum",
            "kind": "LinkedField",
            "name": "forum",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "entitySubscription",
                "plural": false,
                "selections": (v29/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionRule",
            "kind": "LinkedField",
            "name": "latestRule",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionRuleAgreement",
                "kind": "LinkedField",
                "name": "entityAgreement",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v9/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5c117549569f8f1788226bb7ac42c003",
    "id": null,
    "metadata": {},
    "name": "CompetitionScaffoldQuery",
    "operationKind": "query",
    "text": "query CompetitionScaffoldQuery(\n  $eventSlug: String!\n  $competitionSlug: String!\n) {\n  viewer @ifAllowed {\n    __typename\n    id\n  }\n  competitionBySlug(slug: $competitionSlug) {\n    id\n    slug\n    title\n    shortDescription\n    description\n    createdAt\n    banner\n    thumbnail\n    viewerCanEdit: viewerCan(action: UPDATE_COMPETITION)\n    viewerCanEditMembers: viewerCan(action: ADD_COMPETITION_MEMBER)\n    viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n    isPrivate\n    hasLeaderboard\n    requiresApproval\n    currentStage {\n      noCode\n      submissionDeadline\n      id\n    }\n    membership {\n      id\n    }\n    templates(first: 2) {\n      nodes {\n        id\n        version\n        workspace {\n          slug\n          id\n        }\n      }\n    }\n    viewerWorkspace @ifAllowed {\n      id\n      slug\n      publishedVersions: versions(first: 1, filters: {published: true}) {\n        nodes {\n          id\n          version\n        }\n      }\n    }\n    host {\n      __typename\n      id\n      displayName\n      username\n      ...EntityProfilePicFragment_49kWkb\n    }\n    event(slug: $eventSlug) {\n      id\n    }\n    ...CompetitionSetupButtonFragment\n    ...CompetitionJoinButtonFragment\n  }\n}\n\nfragment CompetitionJoinButtonFragment on Competition {\n  id\n  viewerCanAgree: viewerCan(action: CREATE_COMPETITION_RULE_AGREEMENT)\n  viewerCanJoin: viewerCan(action: JOIN_COMPETITION)\n  membership {\n    id\n  }\n  entityRuleAgreements(first: 1) @ifAllowed {\n    nodes {\n      id\n    }\n  }\n  forum {\n    id\n    entitySubscription @ifAllowed {\n      __typename\n      id\n    }\n  }\n  latestRule {\n    id\n    text\n    entityAgreement @ifAllowed {\n      id\n      createdAt\n    }\n  }\n}\n\nfragment CompetitionSetupButtonFragment on Competition {\n  id\n  slug\n  useCase {\n    latest {\n      fileByKind(kind: TEMPLATE) {\n        kind\n        ...ProjectDownloadButtonFragment\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment ProjectDownloadButtonFragment on ProjectVersionFile {\n  id\n  kind\n  extension\n  projectVersion {\n    project {\n      __typename\n      competition {\n        slug\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a0551ab3d9c866e4ea9226d54351c34";

export default node;
